module.exports = __webpack_public_path__ + "img/update-cords__icon.4ebf4337.svg";